export const MAX_TABS = 8;
export const REDIRECT_PATHS = new Set(["/", "/finance", "/inventory", "/hr", "/purchases", "/budgets", "/projects", "/users", "/audit", "/settings"]);

export const EMPTY_TABS = { tabs: [], activeKey: null };

export function syncTabs(state, loc, titleFor, max = MAX_TABS) {
  const key = loc.pathname.length > 1 ? loc.pathname.replace(/\/+$/, "") : loc.pathname;
  const search = loc.search || "";
  const found = state.tabs.find(t => t.key === key);
  if (found) {
    const tabs = found.search === search ? state.tabs : state.tabs.map(t => (t.key === key ? { ...t, search } : t));
    return { state: { tabs, activeKey: key }, blocked: false };
  }
  const reales = state.tabs.filter(t => !REDIRECT_PATHS.has(t.key));
  if (!REDIRECT_PATHS.has(key) && reales.length >= max) return { state, blocked: true };
  const prev = state.tabs.find(t => t.key === state.activeKey);
  const base = prev && REDIRECT_PATHS.has(prev.key) ? state.tabs.filter(t => t.key !== prev.key) : state.tabs;
  return { state: { tabs: [...base, { key, path: key, search, title: titleFor(key) }], activeKey: key }, blocked: false };
}

export function closeTab(state, key) {
  const idx = state.tabs.findIndex(t => t.key === key);
  if (idx < 0) return state;
  const tabs = state.tabs.filter(t => t.key !== key);
  if (state.activeKey !== key) return { tabs, activeKey: state.activeKey };
  const next = tabs[idx] || tabs[idx - 1] || null;
  return { tabs, activeKey: next ? next.key : null };
}

export const NEW_DOC_PREFIX = "n:";

// Presupuestos abiertos dentro del módulo: cada entidad guardada una sola vez; cada borrador sin ID, identidad propia.
export function openBudgetDoc(docs, spec, seq) {
  const { kind, budget, parent } = spec;
  if (kind === "new" || kind === "adicional") {
    const id = `${NEW_DOC_PREFIX}${seq}`;
    return { docs: [...docs, { id, kind, budget: null, parent: parent || null, seq }], activeId: id, seq: seq + 1 };
  }
  const prev = docs.find(d => d.budget?._id && d.budget._id === budget._id);
  if (!prev) {
    const id = `b:${budget._id}`;
    return { docs: [...docs, { id, kind, budget, parent: null }], activeId: id, seq };
  }
  if (prev.kind === "view" && kind === "edit") return { docs: docs.map(d => (d.id === prev.id ? { ...d, kind: "edit", budget } : d)), activeId: prev.id, seq };
  return { docs, activeId: prev.id, seq };
}

export function closeBudgetDoc(docs, activeId, id) {
  const idx = docs.findIndex(d => d.id === id);
  const rest = docs.filter(d => d.id !== id);
  if (activeId !== id) return { docs: rest, activeId };
  const next = rest[idx] || rest[idx - 1] || null;
  return { docs: rest, activeId: next ? next.id : null };
}

export function budgetDocTitle(doc, docs) {
  const b = doc.budget;
  if (b?._id && (doc.kind === "new" || doc.kind === "adicional")) return [b.number, b.nombre].filter(Boolean).join(" · ") || "Presupuesto";
  if (doc.kind === "new") {
    const nuevos = docs.filter(d => d.kind === "new" && !d.budget?._id);
    return nuevos.length > 1 ? `Nuevo presupuesto ${doc.seq}` : "Nuevo presupuesto";
  }
  if (doc.kind === "adicional") return `Adicional de ${doc.parent?.number || doc.parent?.nombre || ""}`.trim();
  return [b?.number, b?.nombre].filter(Boolean).join(" · ") || "Presupuesto";
}
